<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('reportEmployeeDailyTimescan.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('reportEmployeeDailyTimescan.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('reportEmployeeDailyTimescan.criteria') }}</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportEmployeeDailyTimescan.date')
											}}</label>
											<a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
												@change="dateRangeChange">
												<template slot="renderExtraFooter"></template>
											</a-range-picker>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportEmployeeDailyTimescan.branchName')
											}}</label>
											<a-select style="width:100%" v-model.number="model.branch_id" :options="branches"></a-select>
											<div class="validate" v-if="errors.has('branch_id')">
												{{ errors.first('branch_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('reportEmployeeDailyTimescan.employeeName')
											}}</label>
											<a-select v-model="model.staff_id" mode="multiple" :options="employees" placeholder="All"
												:filterOption="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" class="ts-w-full"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('reportEmployeeDailyTimescan.department')
											}}</label>
											<a-select v-model="model.department_id" mode="multiple" :options="departments" placeholder="All"
												:filterOption="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" class="ts-w-full"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('reportEmployeeDailyTimescan.status')
											}}</label>
											<a-select style="width:100%" v-model.number="model.att_pnt_status" :options="acStatus"></a-select>
										</div>
									</div>
									<div class="row" v-show="this.model.att_pnt_status == 'On Time'">
										<div class="col-md-12">
											<label>{{
												$t('reportEmployeeDailyTimescan.statusOnTimeType')
											}}</label>
											<div class="form-group">
												<div class="radio radio-css radio-inline">
													<input v-model="model.report_type" type="radio" id="summary" :value="'Summary'" />
													<label for="summary">
														{{ $t('reportEmployeeDailyTimescan.summary') }}
													</label>
												</div>
												<div class="radio radio-css radio-inline">
													<input v-model="model.report_type" type="radio" id="detail" :value="'Details'" />
													<label for="detail">{{ $t('reportEmployeeDailyTimescan.detail') }} </label>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 text-right">
											<ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
												:waiting="exporting">{{
													$t('excel') }}</ts-button>
										</div>
										<div class="col-md-6 text-right">
											<ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
												$t('preview') }}</ts-button>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('reportEmployeeDailyTimescan.preview') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
	name: 'reportEmployeeDailyTimescan',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			src: '',
			errors: new Errors(),
			branches: [],
			employees: [],
			departments: [],
			acStatus: [],
			rangeDate: [moment().startOf('month'), moment().endOf('month')],
			statuses: [
				{
					value: 1,
					att_pnt_status: 'On Time'
				},
				{
					value: 2,
					att_pnt_status: 'Late'
				},
				{
					value: 3,
					att_pnt_status: 'Absent'
				}
			],
			model: {
				report_type: 'Summary',
				branch_id: null,
				staff_id: undefined,
				department_id: undefined,
				att_pnt_status: 'Late'
			}
		}
	},
	created() {
		this.fetchData()
		this.getStatus()
	},
	methods: {
		...mapActions('reportEmployee', [
			'dailyTimescan',
			'getBranch',
			'getEmployees',
			'getDepartment'
		]),
		moment,
		async fetchData() {
			this.loading = true
			await this.getBranch().then(response => {
				this.branches = response.data.map(el => ({
					value: el.branch_id,
					label: el.branch_name_en
				}))
				this.model.branch_id = this.$store.state.authUser.default_branch_id
			})
			await this.getEmployees().then(response => {
				this.employees = response.data.map(el => ({
					value: el.staff_id,
					label: el.name_en
				}))
			})
			await this.getDepartment().then(response => {
				this.departments = response.data.map(el => ({
					value: el.department_id,
					label: el.department_name_en
				}))
			})
			this.loading = false
		},
		dateRangeChange(dateRange) {
			this.$store.commit(
				'reportEmployee/SET_START_DATE',
				dateRange[0].format('DD-MM-YYYY')
			)
			this.$store.commit(
				'reportEmployee/SET_END_DATE',
				dateRange[1].format('DD-MM-YYYY')
			)
		},
		getStatus() {
			this.acStatus = this.statuses.map(el => ({
				value: el.att_pnt_status,
				label: el.att_pnt_status
			}))
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.dailyTimescan(this.model,)
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		exportExcel() {
			this.exporting = true
			this.errors = new Errors()
			this.$store
				.dispatch('reportEmployee/dailyTimescanExcel', this.model)
				.then(response => {
					let filename = trim(
						response.headers['content-disposition']
							.substring(
								response.headers['content-disposition'].indexOf('filename')
							)
							.replace('filename=', ''),
						'"'
					)
					FileDownload(response.data, filename)
				})
				.catch(err => {
					let error = JSON.parse(
						String.fromCharCode.apply(null, new Uint8Array(err))
					)
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => (this.exporting = false))
		}
	}
}
</script>
  